/** This export is automatically generated */
export const gitHash = '84aa3153';
